import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./relatedSkills.html";
import { Routes } from '~/modules/routes';
import { getRelatedSkills } from '~/modules/services/pluginsService';
import { WireI18n } from '~/modules/stores/i18nStore';
import { SKILL_LISTING_ID_PATTERN } from '~/modules/utilities/listingIdPatterns';
import { getRelatedSkillListingIds } from '~/modules/utilities/skill_utils';
const RELATED_SKILL_CATEGORY_LIMIT = 2;

/** Resolves a skill's curated relationships and supplies skill cards to the shared carousel. */
class RelatedSkills extends LightningElement {
  constructor(...args) {
    super(...args);
    this.labels = void 0;
    this.members = [];
    this._listing = null;
    this.requestVersion = 0;
  }
  get listing() {
    return this._listing;
  }
  set listing(value) {
    if (value === this._listing) {
      return;
    }
    this._listing = value;
    this.fetchMembers(value);
  }
  disconnectedCallback() {
    this.requestVersion += 1;
  }
  async fetchMembers(listing) {
    const requestVersion = ++this.requestVersion;
    const ids = getRelatedSkillListingIds(listing);
    this.members = [];
    if (ids.length === 0) {
      return;
    }
    const members = await getRelatedSkills(ids);
    if (requestVersion !== this.requestVersion) {
      return;
    }

    // OAF validates relatedSkills as canonical SKILL ids. Keep a client-side boundary too so
    // stale/malformed upstream data cannot put a plugin or ordinary app in this section.
    this.members = members.filter(member => member.technology === 'ai-skill' || SKILL_LISTING_ID_PATTERN.test(member.id));
  }
  get heading() {
    return this.labels?.relatedSkillsHeading ?? '';
  }
  get previousLabel() {
    return this.labels?.previousRelatedSkills ?? '';
  }
  get nextLabel() {
    return this.labels?.nextRelatedSkills ?? '';
  }
  get cards() {
    const domainLabels = this.labels?.domains ?? {};
    return this.members.map(member => ({
      oafId: member.id,
      type: 'ai-skill',
      listingUrl: `/${Routes.LISTING}?listingId=${encodeURIComponent(member.id)}`,
      title: member.name,
      publisher: member.publisher,
      description: member.description,
      image: member.logoUrl,
      pricing: '',
      reviewsAmount: 0,
      averageRating: 0,
      listingCategories: [...new Set(member.domains ?? [])].slice(0, RELATED_SKILL_CATEGORY_LIMIT).map(domain => ({
        name: domainLabels[domain] || domain
      })),
      chatEnabled: false,
      sponsored: false
    }));
  }
  get hasCards() {
    return this.members.length > 0;
  }
  get cardCount() {
    return this.members.length;
  }
  get visibleCategoryLimit() {
    return RELATED_SKILL_CATEGORY_LIMIT;
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(RelatedSkills, {
  publicProps: {
    listing: {
      config: 3
    }
  },
  wire: {
    labels: {
      adapter: WireI18n,
      dynamic: [],
      config: function ($cmp) {
        return {
          selector: i18n => i18n.skills
        };
      }
    }
  },
  fields: ["members", "_listing", "requestVersion"]
});
const __lwc_component_class_internal = _registerComponent(RelatedSkills, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;